var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"whatsapp-btn",attrs:{"title":"Share on WhatsApp","href":_vm.urlEncodedMsg,"target":"_blank"}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-whatsapp")]),_vm._v(" SHARE")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }